import React, { Component } from 'react';
import _ from 'lodash'

class LazyImage extends Component {

    constructor(props) {
        super(props);
        this.config = {
            rootMargin: '100px'
        };
    }

    componentDidMount() {        
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps, this.props)) {
            this.reset()            
        }
    }

    init() {
        if (this.supportsIO()) {
            this.observe(this.refs.image);
            this.observer.observe(this.refs.image);
        }
        else {
            this.loadImage();
        }
    }

    reset() {
        this.refs.image.removeAttribute('src')
        this.init()
    }

    supportsIO() {
        return 'IntersectionObserver' in window;
    }

    observe() {
        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {      
                    this.loadImage();
                    this.observer.unobserve(this.refs.image);
                }
            });
        }, this.config);
    }

    loadImage() {
        const loadedImage = new Image();
        loadedImage.src = this.refs.image.dataset.lazy;
        loadedImage.newImage = this.refs.image;
        loadedImage.placeholderImage = this.refs.imagePlaceholder;
        loadedImage.onload = function() {
            loadedImage.newImage.src = this.src;
            if (loadedImage.placeholderImage) {
                setTimeout(() => {
                    loadedImage.placeholderImage.classList.add('u-placeholder-img--is-loaded');
                }, 50);
            }
        }
    }

    render() {
        const { removeWrapper } = this.props

        if (removeWrapper) {
            return <img ref="image" data-lazy={this.props.src} width={this.props.width} height={this.props.height} alt={this.props.alt} />;
        }

        return (
            <div className="u-placeholder-img" ref="imagePlaceholder">
                <img ref="image" data-lazy={this.props.src} width={this.props.width} height={this.props.height} alt={this.props.alt} />
            </div>
        );
    }

}

export default LazyImage;


// WEBPACK FOOTER //
// ./src/components/Global/LazyImage.js